import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Home, Briefcase, Wallet, MapPin, MoreHorizontal, Camera } from "lucide-react";
import NotificationBell from "@/components/NotificationBell";

const TABS = [
  { to: "/driver", icon: Home, label: "Home", exact: true },
  { to: "/driver/work", icon: Briefcase, label: "Work" },
  { to: "/driver/camera", icon: Camera, label: "Camera", featured: true },
  { to: "/driver/pay", icon: Wallet, label: "Pay" },
  { to: "/driver/address-finder", icon: MapPin, label: "Addresses" },
  { to: "/driver/more", icon: MoreHorizontal, label: "More" },
];

const DriverLayout = () => {
  return (
    <div className="min-h-screen bg-brand-surface">
      <div
        className="max-w-md mx-auto min-h-screen bg-white shadow-brand-sm relative pb-20"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="absolute top-2 right-2 z-40"><NotificationBell compact /></div>
        <Outlet />
      </div>
      <nav
        className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white/95 backdrop-blur-xl border-t border-brand-border flex justify-around items-center z-50"
        style={{ height: "calc(4rem + env(safe-area-inset-bottom))",
                  paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="driver-bottom-nav"
      >
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.exact}
            data-testid={`driver-tab-${tab.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-1.5 py-2 rounded-lg min-w-[48px] transition-colors duration-150 ${tab.featured ? "-mt-5" : ""} ${
                isActive ? "text-brand-red" : "text-brand-text-muted hover:text-brand-text"
              }`
            }
          >
            <span className={tab.featured ? "w-12 h-12 rounded-full bg-brand-red text-white grid place-items-center shadow-lg border-4 border-white" : ""}><tab.icon className="w-5 h-5" /></span>
            <span className="text-[10px] font-medium tracking-wide uppercase">{tab.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default DriverLayout;
